import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { DevCenterOverridesClient } from './client.js';

export function useDevCenterOverridesClient({
  siteId,
}: {
  siteId?: string;
} = {}): DevCenterOverridesClient {
  const httpClient = useHttpClient({ type: 'backoffice', siteId });
  const client = useMemo(
    () => new DevCenterOverridesClient(httpClient),
    [httpClient]
  );
  return usePanoramaMethodLogger(client);
}
